<template>
  <div :class="$style.grid_editor_container">
    <grid-input
      type="number"
      :value="value"
      text-align="center"
      :min-value="0"
      :initial-select="true"
      @onInput="handleInput"
    />
  </div>
</template>

<script>
import GridInput from '../components/input.vue';

export default {
  name: 'GridCostCellEditor',
  components: { GridInput },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    handleInput(val) {
      this.value = val;
    },
  },
};
</script>

<style module src="../styles/gridEditor.less" lang="less"></style>
